module.exports = __webpack_public_path__ + "media/images/client-2-083b5372fb5321dbc367a2054ad47585.png";